import React, { useState } from 'react';
import { Row, Col, Form, FormGroup, Label, Input, Table, Button } from 'reactstrap';
import { connect } from 'react-redux';
import * as actionsRedux from '../Store/Actions/index';
import ModalHoc from '../Hoc/modalHoc';
import { axiosApi } from '../Basicos/axiosInstances';

const estiloSecao = {
    color: '#000',
    fontWeight: 700,
    fontSize: '0.95rem',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    marginBottom: '1rem',
    paddingBottom: '0.5rem',
    borderBottom: '1px solid #e9ecef',
};

const estiloLabel = {
    fontWeight: 600,
    fontSize: '0.8rem',
    color: '#495057',
};

const estiloBlocoSemestre = {
    border: '1px solid #e9ecef',
    borderRadius: 4,
    padding: '1rem',
    marginBottom: '1rem',
};

function montarVacinasDoBloco(vacinasDisponiveis, tiposVacinaExigida) {
    const existentesPorVacinaId = {};
    (tiposVacinaExigida || []).forEach((tipo) => {
        existentesPorVacinaId[tipo.vacina_id] = tipo;
    });

    return (vacinasDisponiveis || []).map((vacina) => {
        const existente = existentesPorVacinaId[vacina.id];

        return {
            vacina_id: vacina.id,
            nome: vacina.nome,
            ativo: existente ? existente.ativo : false,
            doses_necessarias: existente ? existente.doses_necessarias : null,
        };
    });
}

function ModalCampanhaVacinacao(props) {
    const { estrutura } = props;
    const { titulo, requisicaoURL, metodoRequisicao } = estrutura.modal;

    const vacinasDisponiveis = estrutura.vacinas_disponiveis || [];
    const semestresDisponiveis = estrutura.semestres_disponiveis || [];

    const [periodoLetivoId, setPeriodoLetivoId] = useState(estrutura.model?.periodo_letivo_id ?? '');
    const [blocos, setBlocos] = useState(() => {
        const semestresDoModel = estrutura.model?.semestres;

        if (semestresDoModel && semestresDoModel.length) {
            return semestresDoModel.map((semestre) => ({
                semestreId: semestre.semestre_id,
                dataInicio: semestre.data_inicio?.slice(0, 10) || '',
                dataFim: semestre.data_fim?.slice(0, 10) || '',
                vacinas: montarVacinasDoBloco(vacinasDisponiveis, semestre.tipos_vacina_exigida),
            }));
        }

        return [];
    });
    const [salvando, setSalvando] = useState(false);

    const tipoDeAcao = metodoRequisicao === 'put' ? 'editar' : 'adicionar';

    const adicionarBloco = () => {
        setBlocos((atual) => [
            ...atual,
            { semestreId: '', dataInicio: '', dataFim: '', vacinas: montarVacinasDoBloco(vacinasDisponiveis, []) },
        ]);
    };

    const removerBloco = (index) => {
        setBlocos((atual) => atual.filter((_, i) => i !== index));
    };

    const atualizarBloco = (index, campo, valor) => {
        setBlocos((atual) => atual.map((bloco, i) => (i === index ? { ...bloco, [campo]: valor } : bloco)));
    };

    const atualizarVacinaDoBloco = (indexBloco, indexVacina, campo, valor) => {
        setBlocos((atual) => atual.map((bloco, i) => {
            if (i !== indexBloco) return bloco;

            return {
                ...bloco,
                vacinas: bloco.vacinas.map((vacina, j) => (j === indexVacina ? { ...vacina, [campo]: valor } : vacina)),
            };
        }));
    };

    const semestresDisponiveisParaBloco = (semestreIdAtual) => {
        const usadosPorOutrosBlocos = blocos
            .map((bloco) => bloco.semestreId)
            .filter((semestreId) => semestreId && semestreId !== semestreIdAtual);

        return semestresDisponiveis.filter((semestre) => !usadosPorOutrosBlocos.includes(semestre.id));
    };

    const salvar = async () => {
        setSalvando(true);

        try {
            const response = await axiosApi({
                method: metodoRequisicao,
                url: requisicaoURL,
                data: {
                    periodo_letivo_id: periodoLetivoId,
                    semestres: blocos.map((bloco) => ({
                        semestre_id: bloco.semestreId,
                        data_inicio: bloco.dataInicio,
                        data_fim: bloco.dataFim,
                        vacinas: bloco.vacinas.map((vacina) => ({
                            vacina_id: vacina.vacina_id,
                            ativo: vacina.ativo,
                            doses_necessarias: vacina.doses_necessarias === '' ? null : vacina.doses_necessarias,
                        })),
                    })),
                },
            });

            props.ativar(tipoDeAcao, 'sucesso');
            if (props[tipoDeAcao]) props[tipoDeAcao](response.data.model);
            props.toggle();
        } catch (error) {
            if (error.response && error.response.data.erro) {
                props.ativar(error.response.status, error.response.data.erro);
            } else {
                props.ativar(tipoDeAcao, 'erro');
            }
        } finally {
            setSalvando(false);
        }
    };

    return (
        <>
            <Row noGutters style={{ borderBottom: '1px solid #e9ecef' }}>
                <Col sm={12} className="align-content-middle mb-2 mt-2 pb-2">
                    <h4><b>{titulo}</b></h4>
                </Col>
            </Row>
            <Form className="text-secondary p-4">
                <div style={estiloSecao}>Período Letivo</div>
                <Row form className="align-items-end">
                    <Col md={6}>
                        <FormGroup>
                            <Label style={estiloLabel}>Período Letivo</Label>
                            <Input type="select" value={periodoLetivoId} onChange={(e) => setPeriodoLetivoId(e.target.value)} required>
                                <option value="">Selecione...</option>
                                {(estrutura.periodos_letivos || []).map((periodo) => (
                                    <option key={periodo.value} value={periodo.value}>{periodo.label}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>

                <div style={{ ...estiloSecao, marginTop: '1.5rem' }}>Janelas por semestre</div>
                <p className="text-muted" style={{ marginTop: '-0.5rem' }}>
                    Cada semestre tem sua própria data de envio e suas próprias vacinas exigidas — permite abrir o período
                    gradualmente, semestre por semestre.
                </p>

                {blocos.map((bloco, indexBloco) => (
                    <div key={indexBloco} style={estiloBlocoSemestre}>
                        <Row form className="align-items-end">
                            <Col md={4}>
                                <FormGroup>
                                    <Label style={estiloLabel}>Semestre</Label>
                                    <Input
                                        type="select"
                                        value={bloco.semestreId}
                                        onChange={(e) => atualizarBloco(indexBloco, 'semestreId', e.target.value)}
                                        required
                                    >
                                        <option value="">Selecione...</option>
                                        {semestresDisponiveisParaBloco(bloco.semestreId).map((semestre) => (
                                            <option key={semestre.id} value={semestre.id}>{semestre.descricao}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Label style={estiloLabel}>Data Início</Label>
                                    <Input
                                        type="date"
                                        value={bloco.dataInicio}
                                        onChange={(e) => atualizarBloco(indexBloco, 'dataInicio', e.target.value)}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Label style={estiloLabel}>Data Fim</Label>
                                    <Input
                                        type="date"
                                        value={bloco.dataFim}
                                        onChange={(e) => atualizarBloco(indexBloco, 'dataFim', e.target.value)}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={2} className="mb-3">
                                <Button color="danger" outline size="sm" onClick={() => removerBloco(indexBloco)}>
                                    Remover
                                </Button>
                            </Col>
                        </Row>

                        <Table size="sm" bordered className="align-middle mb-0">
                            <thead>
                                <tr style={{ backgroundColor: '#f8f9fa' }}>
                                    <th style={{ width: 40, textAlign: 'center' }}></th>
                                    <th>Vacina</th>
                                    <th style={{ width: 160 }}>Doses exigidas</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bloco.vacinas.map((vacina, indexVacina) => (
                                    <tr key={vacina.vacina_id}>
                                        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                            <input
                                                type="checkbox"
                                                style={{ width: 16, height: 16, margin: 0 }}
                                                checked={vacina.ativo}
                                                onChange={(e) => atualizarVacinaDoBloco(indexBloco, indexVacina, 'ativo', e.target.checked)}
                                            />
                                        </td>
                                        <td style={{ verticalAlign: 'middle', fontWeight: 600, color: '#333' }}>{vacina.nome}</td>
                                        <td style={{ verticalAlign: 'middle' }}>
                                            <Input
                                                type="number"
                                                min="1"
                                                bsSize="sm"
                                                disabled={!vacina.ativo}
                                                value={vacina.doses_necessarias ?? ''}
                                                onChange={(e) => atualizarVacinaDoBloco(indexBloco, indexVacina, 'doses_necessarias', e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                ))}

                <Button color="secondary" outline onClick={adicionarBloco}>+ Adicionar semestre</Button>
            </Form>
            <Col sm={12} className="align-content-middle mb-3 p-0">
                <Button onClick={props.toggle} className="float-right btn-transparente">Cancelar</Button>
                <Button onClick={salvar} disabled={salvando || !blocos.length} className="float-right">Salvar</Button>
            </Col>
        </>
    );
}

const mapDispatchToProps = (dispatch) => {
    return {
        ativar: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao)),
        desativar: () => dispatch(actionsRedux.desativarAlert()),
    };
};

export default connect(null, mapDispatchToProps)(ModalHoc(ModalCampanhaVacinacao));
